import type { BaseVideoClickTracker } from '@/analytics/base_video_click_tracker';
import type { MagicVariables } from '@/types';

export class ToggleMoreVideos implements MagicVariables {
    $root: MagicVariables['$root'];
    $refs: MagicVariables['$refs'];
    trackVideoClick: BaseVideoClickTracker;

    isOpen: boolean = false;

    constructor(trackVideoClick: BaseVideoClickTracker) {
        this.trackVideoClick = trackVideoClick;
    }

    init() {
        this.trackVideoClick.init(this.$root, this.$refs);
    }

    toggle(): void {
        this.isOpen = !this.isOpen;
    }

    getChevronIcon(): string {
        return this.isOpen ? svg_icon('icon-chevron-up') : svg_icon('icon-chevron-down');
    }
}
